import React from 'react';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';
import { SalesforceLoader, ScriptLoader } from '@swf/help';

const HelpBotWidget = () => {
  const shouldOpenSFChat = useSelector(select.help.getShouldOpenSFChat);

  if (shouldOpenSFChat) {
    return <SalesforceLoader />;
  } else {
    return <ScriptLoader />;
  }
};

export default HelpBotWidget;
